import React, { useState } from "react";
import styled from "styled-components";

export default function SearchInput({
  onChange,
  width,
  placeholder = "Search",
}) {
  const [readOnly, setReadOnly] = useState(false);

  return (
    <AppInputStyle style={{ width: width }}>
      <svg
        className="eye"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.3636 15.184L12.4745 11.2958C13.5177 10.0967 14.1493 8.53215 14.1493 6.82217C14.1493 3.05809 11.087 0 7.32564 0C3.56072 0 0.501953 3.06164 0.501953 6.82217C0.501953 10.5827 3.56427 13.6443 7.32564 13.6443C9.036 13.6443 10.6009 13.0129 11.8002 11.9698L15.6894 15.8581C15.7816 15.9503 15.9058 16 16.0265 16C16.1471 16 16.2713 15.9539 16.3636 15.8581C16.5481 15.6736 16.5481 15.3685 16.3636 15.184ZM1.45649 6.82217C1.45649 3.5867 4.08944 0.957871 7.32209 0.957871C10.5583 0.957871 13.1877 3.59024 13.1877 6.82217C13.1877 10.0541 10.5583 12.69 7.32209 12.69C4.08944 12.69 1.45649 10.0576 1.45649 6.82217Z"
          fill="#313A4E"
        />
      </svg>

      <input
        type="text"
        placeholder={placeholder}
        onChange={onChange}
        autocomplete="off"
        readOnly={readOnly}
        onFocus={() => setReadOnly(false)}
        onBlur={() => setReadOnly(true)}
      />
    </AppInputStyle>
  );
}

const AppInputStyle = styled.div`
  width: 100%;
  outline: none;
  border-radius: 10px;
  background-color: none;
  padding: 0;
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid #e1e1e1;
  margin-right: 10px;

  input {
    width: 100%;
    height: 100%;
    appearance: none;
    border-radius: 8px;
    outline: none;
    border: none;
    background: none;
    padding: 15px 15px;
    font-size: 16px;
    margin: 0px 10px;
  }
  input::placeholder {
    color: #9b9b9b;
  }

  .eye {
    cursor: pointer;
    margin-left: 14px;
  }
`;
